import axios from '@/config/qy.axios.config';
import siteApi from "@/api/site";
export const qyWeixin = {
    config() {
        var url = encodeURIComponent(location.href.split("#")[0]);
        var jsApiList = [
            'scanQRCode',//扫一扫
            'getLocation',//获取位置
            'openLocation',//打开地图
            'stopRecord',
            'uploadVoice',
            'playVoice',
        ];
        axios({
            method: "get",
            url: siteApi.getCorpConfigUrl,
            noToast: true,
            noLogin: true,
            params: {
                url,
            },
            noToast: true,
        }).then(data => {
            wx.config({
                beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: data.corpid, // 必填，企业微信的corpID
                timestamp: data.timestamp, // 必填，生成签名的时间戳
                nonceStr: data.nonceStr, // 必填，生成签名的随机串
                signature: data.signature,// 必填，签名，见 附录-JS-SDK使用权限签名算法
                jsApiList: jsApiList // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });
        });
    }
};